<script setup>
import {ref, computed} from 'vue'

const props = defineProps({
  benchmark: Object,
  parentDuration: Number
})

const open = ref(false)

const toggleOpen = () => {
  open.value = !open.value
}

const durationToString = (duration) => {
  if(duration > 1000000000) {
    return (duration / 1000000000).toFixed(2) + ' s'
  } else if(duration > 1000000) {
    return (duration / 1000000).toFixed(2) + ' ms'
  } else if(duration > 1000) {
    return (duration / 1000).toFixed(2) + ' µs'
  } else {
    return duration.toFixed(2) + ' ns'
  }
}

//computed parentDuration
const parentDuration = computed(() => {
  return props.parentDuration == 0 ? props.benchmark.duration : props.parentDuration;
})

//combine children with the same name and move these to a new group but also hold each child as a single item in the new group
/*
const combineChildren = (children) => {

  //count children with the same name
  let childrenMap = {}
  children.forEach(child => {
    if(childrenMap[child.name]) {
      childrenMap[child.name].push(child)
    } else {
      childrenMap[child.name] = [child]
    }
  });

  

  //create new children array
  let newChildren = []
  for(const key in childrenMap) {
    if(childrenMap[key].length > 1) {
      newChildren.push({
        name: key,
        duration: childrenMap[key].reduce((acc, cur) => acc + cur.duration, 0),
        children: childrenMap[key]
      })
    } else {
      newChildren.push(childrenMap[key][0])
    }
  }

  return newChildren
}
*/

const combineChildren = (children) => {
  const result = []
  const map = new Map()
  for (const child of children) {
    if(map.has(child.name)) {
      map.get(child.name).times += 1
      map.get(child.name).duration += child.duration
    } else {

      map.set(child.name, {
        name: child.name,
        duration: child.duration,
        times: 1,
        children: child.children
      })
    }
  }
  for (const [key, value] of map) {
    result.push(value)
  }
  return result
}


//create color from percent number from 0 to 100 from green to higher red
const getColor = (percent) => {
  let g = percent < 50 ? 255 : Math.floor(255 - (percent * 2 - 100) * 255 / 100);
  let r = percent > 50 ? 255 : Math.floor((percent * 2) * 255 / 100);
  return 'rgb(' + r + ',' + g + ',0)';
}

</script>

<template>
  <div>
    <div>

      <div @click="toggleOpen" class="m-1 bg-trader-gray flex gap-2 items-center p-1 cursor-pointer hover:bg-trader-dark-gray">

        <div class="w-6 text-center">
          <div v-if="props.benchmark.children.length > 0">
            <i v-if="!open" class="fa-solid fa-chevron-right"></i>
            <i v-if="open" class="fa-solid fa-chevron-down"></i>
          </div>
        </div>

        <div>
          <span v-if="props.benchmark?.times > 1" class="font-bold">{{ props.benchmark?.times}} x </span>{{ props.benchmark.name }}
        </div>
        <span class="flex-grow"></span>

        <div class="w-[50px] text-right">{{((100/parentDuration) * props.benchmark.duration).toFixed(2) + '%'}}</div>
        <div class="bg-trader-dark-gray w-[300px] rounded overflow-hidden">
          <div :style="{width: (100/parentDuration) * props.benchmark.duration + '%', 'background-color' : getColor((100/parentDuration) * props.benchmark.duration)}" class=" h-3">
          </div>

        </div>
        <span class=" w-[100px] text-right">{{ durationToString(props.benchmark.duration) }}</span>
      </div>

      <div class="ml-5" v-if="open">
        <BenchmarkItem v-for="item in combineChildren(props.benchmark.children)" :benchmark="item" :parent-duration="parentDuration">
        </BenchmarkItem>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>